"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = require("./style");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Select = function (_PureComponent) {
  (0, _inherits2["default"])(Select, _PureComponent);

  var _super = _createSuper(Select);

  function Select(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Select);
    _this = _super.call(this, props);

    _this.onSetValue = function (value) {
      var handleChange = _this.props.handleChange;
      var options = _this.state.options;
      var selectedIndex = options.findIndex(function (el) {
        return el.title === value;
      });
      if (handleChange && value !== '') handleChange(options[selectedIndex].value);

      _this.setState({
        focused: false,
        selected: selectedIndex,
        value: value
      });
    };

    _this.handleNavigation = function (e) {
      var handleChange = _this.props.handleChange;
      var _this$state = _this.state,
          options = _this$state.options,
          selected = _this$state.selected;

      if (e.target.value === '') {
        _this.setState({
          focused: true
        });
      }

      if (e.which === 40) {
        _this.setState(function (prevState) {
          return {
            selected: prevState.selected < prevState.options.length ? prevState.selected + 1 : 0
          };
        });
      }

      if (e.which === 38) {
        _this.setState(function (prevState) {
          return {
            selected: prevState.selected >= 0 ? prevState.selected - 1 : 0
          };
        });
      }

      if (e.which === 13 && selected >= 0 && options[selected]) {
        if (handleChange) handleChange(options[selected].value);

        _this.setState(function (prevState) {
          return {
            value: prevState.options[prevState.selected].title,
            focused: false
          };
        }, e.target.blur());
      }
    };

    _this.onFocus = function () {
      _this.setState({
        focused: true
      });
    };

    _this.onBlur = function (e) {
      _this.setState({
        value: e.target.value,
        focused: false
      });
    };

    _this.onScrollOptions = function (element) {
      var whereIShouldStart = Math.floor(element.target.scrollTop / 50) - 15 > 0 ? Math.floor(element.target.scrollTop / 50) : 0;
      var whereIShouldFinish = Math.floor(Math.floor(element.target.scrollTop / 50) + 15);

      _this.setState(function (prevState) {
        return {
          optionsToShow: prevState.options.slice(whereIShouldStart, whereIShouldFinish),
          firstItemNumber: whereIShouldStart,
          selected: -1
        };
      });
    };

    var defaultSelectedIndex = props.value && props.options.findIndex(function (option) {
      return option.value === props.value;
    });
    var defaultSelected = props.options[defaultSelectedIndex] || {};
    _this.state = {
      focused: false,
      value: Object.keys(defaultSelected).length ? defaultSelected.title : '',
      options: props.options,
      firstItemNumber: 0,
      selected: defaultSelectedIndex || -1
    };
    return _this;
  }

  (0, _createClass2["default"])(Select, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          dataTestValue = _this$props.dataTestValue,
          label = _this$props.label,
          extraInfo = _this$props.extraInfo,
          id = _this$props.id,
          helper = _this$props.helper,
          error = _this$props.error;
      var _this$state2 = this.state,
          focused = _this$state2.focused,
          value = _this$state2.value,
          options = _this$state2.options,
          firstItemNumber = _this$state2.firstItemNumber,
          selected = _this$state2.selected;
      return _react["default"].createElement(_style.Container, null, extraInfo && _react["default"].createElement(_style.Extra, null, extraInfo), _react["default"].createElement(_style.Label, {
        active: value !== '' || focused,
        focused: focused
      }, label), _react["default"].createElement(_style.InputContainer, {
        focused: focused,
        error: error
      }, _react["default"].createElement("input", {
        "data-test-value": dataTestValue,
        onChange: this.handleNavigation,
        onKeyUp: this.handleNavigation,
        type: "text",
        id: id || '',
        value: value || '',
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        readOnly: true
      }), _react["default"].createElement("span", null, helper)), _react["default"].createElement(_style.Options, {
        focused: focused,
        onScroll: this.onScrollOptions
      }, _react["default"].createElement(_style.ScrollContainer, {
        optionsLength: options.length
      }, options.map(function (selection, i) {
        return _react["default"].createElement(_style.Option, {
          key: selection.title,
          "data-value": selection.value,
          "data-key": "select-".concat(i),
          role: "link",
          tabIndex: "0",
          featured: selected !== i && selection.featured,
          selected: selected === i,
          onMouseDown: function onMouseDown() {
            return _this2.onSetValue(selection.title);
          },
          itemNumber: firstItemNumber + i
        }, _react["default"].createElement(_style.Ellipsis, null, selection.title));
      }))));
    }
  }]);
  return Select;
}(_react.PureComponent);

Select.propTypes = {
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  dataTestValue: _propTypes["default"].string,
  extraInfo: _propTypes["default"].string,
  label: _propTypes["default"].string.isRequired,
  handleChange: _propTypes["default"].func,
  id: _propTypes["default"].string,
  value: _propTypes["default"].string,
  helper: _propTypes["default"].string,
  error: _propTypes["default"].string
};
Select.defaultProps = {
  dataTestValue: undefined,
  extraInfo: undefined,
  handleChange: function handleChange() {},
  id: undefined,
  value: undefined,
  helper: undefined,
  error: undefined
};
var _default = Select;
exports["default"] = _default;